import React, { useState } from 'react';

// Lightweight loading image component
function LoadingImage({ src, alt, className }) {
  const [isLoading, setIsLoading] = useState(true);

  return (
    <div className="relative">
      {isLoading && (
        <div className="absolute inset-0 flex items-center justify-center bg-gray-800/20 rounded-lg">
          <div className="w-6 h-6 border-2 border-gray-600 border-t-purple-400 rounded-full animate-spin"></div>
        </div>
      )}
      <img
        src={src}
        alt={alt}
        className={`${className} ${isLoading ? 'opacity-0' : 'opacity-100'} transition-opacity duration-300`}
        onLoad={() => setIsLoading(false)}
        onError={() => setIsLoading(false)}
      />
    </div>
  );
}

function FAQItem({ question, answer }) {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div className="bg-gradient-to-r from-gray-800/60 to-gray-900/60 rounded-xl border border-gray-700/50 overflow-hidden transition-all duration-300 hover:border-purple-500/30">
      <button
        onClick={() => setIsExpanded(!isExpanded)}
        className="w-full px-6 py-4 text-left flex items-center justify-between focus:outline-none focus-visible:ring-2 focus-visible:ring-purple-500/50 rounded-xl"
      >
        <h3 className="text-lg font-semibold text-white pr-4">{question}</h3>
        <div className={`transform transition-transform duration-300 flex-shrink-0 ${isExpanded ? 'rotate-180' : ''}`}>
          <svg 
            className="w-5 h-5 text-purple-400" 
            fill="none" 
            stroke="currentColor" 
            viewBox="0 0 24 24"
          >
            <path 
              strokeLinecap="round" 
              strokeLinejoin="round" 
              strokeWidth={2} 
              d="M19 9l-7 7-7-7" 
            />
          </svg>
        </div>
      </button>
      
      <div 
        className={`overflow-hidden transition-all duration-300 ease-in-out ${
          isExpanded ? 'max-h-screen opacity-100' : 'max-h-0 opacity-0'
        }`}
      >
        {isExpanded && (
          <div className="px-6 pb-6 text-left text-gray-300 border-t border-gray-700/30 pt-4">
            {answer}
          </div>
        )}
      </div>
    </div>
  );
}

export { LoadingImage };
export default FAQItem; 